<template>
  <div class="search">
    <div class="top">
      <p class="el-icon-back back" @click="goBack">返回</p>
      <el-input placeholder='搜索保单或受保障人' type='text' v-model="keywords"></el-input>
      <el-button type='primary' @click="currentPage = 1;getList()">搜索</el-button>
    </div>
    <el-table empty-text="暂无数据" :data="tableData" border>
      <el-table-column prop="number" label="序号" min-width="50%">
      </el-table-column>
      <el-table-column prop="casenumber" label="案件编号" min-width="80">
      </el-table-column>
      <el-table-column prop="address" label="发生地点" min-width="100%">
      </el-table-column>
      <el-table-column prop="username" label="用户姓名" min-width="50%">
      </el-table-column>
      <el-table-column prop="phone" label="用户手机号" min-width="70%">
      </el-table-column>
      <el-table-column prop="papers" label="证件信息" min-width="70%">
      </el-table-column>
      <el-table-column prop="sex" label="性别" min-width="40%">
      </el-table-column>
      <el-table-column prop="time" label="出险时间" min-width="90%">
      </el-table-column>
      <el-table-column prop="insurancePolicyNo" label="保单号" min-width="90%">
      </el-table-column>
      <el-table-column prop="par" label="用户保险详情" min-width="70%">
        <template slot-scope="scope">
          <el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">保险详情</el-button>
          <el-button type="text" size="small" v-show="!scope.row.isshow">无</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="plan" label="当前进度" min-width="80%">
      </el-table-column>
      <el-table-column prop="op" label="操作" min-width="90%">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="topar(scope.row.caseId)">案件详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
  import {
    searchCase
  } from '@/views/axios/api'
  import constants from '@/util/constants.js';
  export default {
    data() {
      return {
        tableData: [],
        token: JSON.parse(window.localStorage.getItem("data")).data,
        obj: [],
        currentPage:1,
        pageSize:10,
        total:100,
        keywords:''
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize=val;
        this.getList()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage=val;
        this.getList()
      },
      goBack() {
        this.$router.go(-1)
      },
      getList() {
        let n = 0;
        let sex = "";
        let isshow = false;
        this.tableData=[]
        let data = {
          token: this.token,
          start: this.pageSize*(this.currentPage - 1),
          count: this.pageSize,
          keywords: this.keywords
        }
        searchCase(data)
          .then(res => {
            this.total=res.data.obj.obj2
            res.data.obj.obj.map(v => {
              n = n + 1;
              if (v.victimList.length != 0) {
                if (v.victimList[0].obj.gender == 1) {
                  sex = "男";
                } else {
                  sex = "女";
                }
                if (v.victimList[0].obj.insurancePolicyNo && v.victimList[0].obj.insurancePolicyNo != "") {
                  isshow = true;
                } else {
                  isshow = false;
                }
              }
              var pt = constants.pt2txt2(v.obj.caseState);
              var address = ''
              if (v.generalLocation) {
                if (!constants.setTxt(v.generalLocation.addr, 'zh')) {
                  address = v.generalLocation.addr
                } else {
                  address = this.languageIndex == 0 ? constants.setTxt(v.generalLocation.addr, 'zh') : constants.setTxt(
                    v.generalLocation.addr, 'en')
                }
              }
              this.tableData.push({
                number: n, //序号
                casenumber: v.obj.caseNo, //案件编号
                caseId: v.obj.initialCaseId,
                address, //地址
                username: v.victimList[0].obj.victimName, //姓名
                phone: v.obj.reporterContact, //联系方式
                papers: v.victimList[0].obj.idNo || "无", //身份证号
                sex: sex, //性别
                time: constants.time(v.obj.incidentTs), //出险时间
                isshow: isshow, //保单
                insuranceUrl: v.insuranceUrl,
                plan: pt.phase, //进度
                get_time: constants.time(v.obj.incidentTs),
                op: "查看并操作",
                insurancePolicyNo:v.victimList[0].obj.insurancePolicyNo
              });
            });
          })
      },
      topar(id) {
        this.$router.push({
          path: '/cmd_center/caseDetails',
          query: {
            caseid: id
          },
        });
      }
    }
  }
</script>

<style scoped="scoped">
  .search {
    width: 1200px;
    margin: 0 auto;
    background-color: white;
    padding: 20px;
    padding-bottom: 50px;
  }

  .top {
    margin-bottom: 20px;
  }

  .top .el-input {
    width: 300px;
    margin: 0 20px;
  }

  .back {
    cursor: pointer;
  }
  .page{text-align: right;margin-top: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/search.vue